import { Link } from "@mui/material"

import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"

type PreviewToggleLinkProps = Readonly<{
    isOpen: boolean
    onToggle: () => void
}>

export function PreviewToggleLink({ isOpen, onToggle }: PreviewToggleLinkProps) {
    return (
        <LocalizedStrict id={isOpen ? "adjust-price-list-preview-hide" : "adjust-price-list-preview-show"}>
            <Link component="button" type="button" variant="body2" onClick={onToggle}>
                {isOpen ? "Hide" : "Show prices"}
            </Link>
        </LocalizedStrict>
    )
}
